'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const RubbishBinIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="RubbishBinIcon">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4012_13325)">
          <path
            d="M15.4688 3.60938L14.1664 15.9783C14.1293 16.3315 13.9627 16.6584 13.6989 16.8961C13.4351 17.1338 13.0926 17.2654 12.7375 17.2656H5.2625C4.90727 17.2656 4.56462 17.1341 4.30063 16.8964C4.03665 16.6587 3.87003 16.3316 3.83291 15.9783L2.53125 3.60938"
            stroke="#3D517B"
            strokeOpacity="0.560784"
            strokeWidth="0.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.734375 3.60938H17.2656"
            stroke="#3D517B"
            strokeOpacity="0.560784"
            strokeWidth="0.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.76562 3.60938V1.45312C5.76562 1.2625 5.84135 1.07968 5.97614 0.944892C6.11093 0.8101 6.29375 0.734375 6.48438 0.734375H11.5156C11.7062 0.734375 11.8891 0.8101 12.0239 0.944892C12.1586 1.07968 12.2344 1.2625 12.2344 1.45312V3.60938"
            stroke="#3D517B"
            strokeOpacity="0.560784"
            strokeWidth="0.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 6.84375V14.3906"
            stroke="#3D517B"
            strokeOpacity="0.560784"
            strokeWidth="0.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.2344 6.84375L11.875 14.3906"
            stroke="#3D517B"
            strokeOpacity="0.560784"
            strokeWidth="0.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.76562 6.84375L6.125 14.3906"
            stroke="#3D517B"
            strokeOpacity="0.560784"
            strokeWidth="0.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_4012_13325">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

RubbishBinIcon.propTypes = {
  sx: PropTypes.object
}
